import { SET_BIDS_TEXT_VALUE } from "../action";

export const setMachine = (machine) => {
  const arrOfMachine = machine.split("-");
  return (dispatch) => {
    dispatch({
      type: SET_BIDS_TEXT_VALUE,
      payload: {
        make: arrOfMachine[0],
        model: arrOfMachine[1],
        category: arrOfMachine[2],
      },
    });
  };
};
